// Theme color definitions for Light and Dark modes

export const LightTheme = {
  // Primary Colors
  primary: '#C4963E', // Gold
  primaryLight: '#D4A655',
  primaryDark: '#A67D2E',
  accent: '#C4963E', // Gold accent
  accentLight: '#D4A655',
  accentDark: '#A67D2E',

  // Background Colors
  background: '#F3F2EF',
  backgroundSecondary: '#F3F2EF',
  backgroundTertiary: '#FAFAFA',
  card: '#FFFFFF',
  
  // Text Colors
  text: '#000000',
  textSecondary: '#666666',
  textTertiary: '#999999',
  textInverse: '#FFFFFF',
  
  // Border Colors
  border: '#E0E0E0',
  borderLight: '#F0F0F0',
  borderDark: '#D0D0D0',
  
  // Status Colors
  success: '#2E7D32',
  error: '#E74C3C',
  errorLight: '#FADBD8',
  warning: '#F39C12',
  info: '#0A66C2',
  
  // Overlay
  overlay: 'rgba(0, 0, 0, 0.5)',
  
  // Special
  shadow: '#000000',
  disabled: '#CCCCCC',
  placeholder: '#999999',
};

export const DarkTheme = {
  // Primary Colors
  primary: '#C4963E', // Gold as primary in dark mode
  primaryLight: '#D4A655',
  primaryDark: '#A67D2E',
  accent: '#C4963E', // Gold accent
  accentLight: '#D4A655',
  accentDark: '#A67D2E',

  // Background Colors
  background: '#181A1C',
  backgroundSecondary: '#1A1A1A',
  backgroundTertiary: '#2A2A2A',
  card: '#1A1A1A',
  
  // Text Colors
  text: '#FFFFFF',
  textSecondary: '#B0B0B0',
  textTertiary: '#808080',
  textInverse: '#000000',
  
  // Border Colors
  border: '#333333',
  borderLight: '#2A2A2A',
  borderDark: '#404040',
  
  // Status Colors
  success: '#4CAF50',
  error: '#F44336',
  errorLight: '#FADBD8',
  warning: '#FFC107',
  info: '#D4AF37',
  
  // Overlay
  overlay: 'rgba(0, 0, 0, 0.8)',
  
  // Special
  shadow: '#000000',
  disabled: '#404040',
  placeholder: '#666666',
};

export type Theme = typeof LightTheme;

export const themes = {
  light: LightTheme,
  dark: DarkTheme,
};

export type ThemeMode = 'light' | 'dark' | 'system';
